import React from "react";
import { useHistory } from "react-router-dom";
import Button from '@mui/material/Button';
import CheckIcon from "../../assets/icons/CheckIcon";
import { Close } from "@material-ui/icons";

const ResetPasswordOk = () => {
    let history = useHistory();

    const redirect = () => {
        history.push({
            pathname: `/login`,
        })
    }
    return (
        <>
            {(
                <div
                    className="modal-container">
                    <div className="pop-up-modal-ok col-sm-10 col-xl-6 container">
                        <div className="col-1 close-icon offset-11 mb-5 pb-3">
                            <Button className="col" id="redirect-button" onClick={redirect} >
                                <Close/>
                            </Button>
                        </div>
                        <div className="row mt-5 pt-5">
                           <CheckIcon/>
                        </div>
                        <div className="col-8 offset-2 text-center mt-4">
                            <h2>Has cambiado la
                                contraseña</h2>
                        </div>
                        <div className="row">
                            <div className="col-8 offset-2 text-center mt-2">
                                <p>Ya puedes acceder con tu nueva clave.</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center">
                            <Button onClick={redirect}>
                                <span className="btn-inicio col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-sm-5">Ir al inicio</span>
                            </Button>
                        </div>
                    </div>
                </div >
            )}
        </>
    );
}

export default ResetPasswordOk;
